import { render, staticRenderFns } from "./MainDrawer.vue?vue&type=template&id=a5ba2cfe"
import script from "./MainDrawer.vue?vue&type=script&lang=js"
export * from "./MainDrawer.vue?vue&type=script&lang=js"
import style0 from "./MainDrawer.vue?vue&type=style&index=0&id=a5ba2cfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports